import fuzzaldrin from 'fuzzaldrin';
const lsPrefix = "murimi247-admin-";

export const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat'];

export const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function mdy(date) {
  return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`
}

export function ls(key) {
  return window.localStorage.getItem(lsPrefix + key);
}

export function lsSet(key, val) {
  window.localStorage.setItem(lsPrefix + key, JSON.stringify(val));
}

export function lsRemove(key, val) {
  window.localStorage.removeItem(lsPrefix + key);
}

export function lsClear() {
  window.localStorage.clear();
}

export function randomIntFromInterval(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

export function capitalizeFirstLetter() {
  return this.charAt(0).toUpperCase() + this.slice(1);
}

export function ucFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function getOrdinal(n) {
  var s=["th","st","nd","rd"],
  v=n%100;
  return n+(s[(v-20)%10]||s[v]||s[0]);
}

export function convertToCSV(objArray) {
  var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
  var str = '';

  for (var i = 0; i < array.length; i++) {
      var line = '';
      for (var index in array[i]) {
          if (line != '') line += ','

          line += array[i][index];
      }

      str += line + '\r\n';
  }

  return str;
}

export function exportCSVFile(headers, items, fileTitle) {
  if (headers) {
      items.unshift(headers);
  }

  // Convert Object to JSON
  var jsonObject = JSON.stringify(items);

  var csv = convertToCSV(jsonObject);

  var exportedFilenmae = fileTitle + '.csv' || 'export.csv';

  var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  if (navigator.msSaveBlob) { // IE 10+
      navigator.msSaveBlob(blob, exportedFilenmae);
  } else {
      var link = document.createElement("a");
      if (link.download !== undefined) { // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", exportedFilenmae);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
      }
  }
}


export const currencies = ['USD', 'ZW'];

export const cleanStr = (string) => string.replace(/,/g, '').replace(/(\r\n|\n|\r)/gm," ");

export const nextDate = () => {
  const today = new Date();
  today.setDate(today.getDate() + 1);
  return today;
}

export const harareSuburbs = ["Adylinn", "Alexandra Park", "Amby", "Arcadia", "Ardbennie", "Ashbrittle", "Ashdown Park", "Aspindale Park", "Athlone", "Avenues", "Avondale", "Avondale West", "Avonlea", "Ballantyne Park", "Belgravia", "Belvedere", "Belvedere North", "Belvedere South", "Bloomingdale", "Bluff Hill", "Borrowdale", "Borrowdale Brooke", "Borrowdale West", "Braeside", "Breeze Valley", "Brooke Ridge", "Brookeview", "Budiriro", "Chadcombe", "Chiremba Park", "Chisipite", "Colne Valley", "Colray", "Cranborne Park", "Crowborough", "Dzivaresekwa", "Eastlea", "Emerald Hill", "Epworth", "Glaudina", "Glen Forest", "Glen Lorne", "Glen Norah", "Glen View", "Gletwyn", "Graniteside", "Greencroft", "Greendale", "Greengrove", "Greystone Park", "Grobbie Park", "Groombridge", "Gunhill", "Haig Park", "CBD", "Hatfield", "Helensvale", "Highfield", "Highlands", "Hilside", "Hogerty Hill", "Hopley", "Houghton Park", "Induna", "Kambanji", "Kambuzuma", "Kensington", "Kuwadzana", "Lewisham", "Lichendale", "Lincoln Green", "Little Norfolk", "Lochinvar", "Logan Park", "Luna", "Mabelreign", "Mabvuku", "Mainway Meadows", "Malvern", "Mandara", "Manresa", "Marimba Park", "Marlborough", "Matidora Park", "Mayfield Park", "Mbare", "Meyrick Park", "Midlands", "Milton Park", "Monovale", "Mount Hampden", "Mount Pleasant", "Mount Pleasant Heights", "Msasa", "Msasa Park", "Mufakose", "New Alexandra Park", "New Ardbennie", "New Marlborough", "Newlands", "Nkwisi Park", "Northwood", "Old Forest", "Park Meadowlands", "Parktown", "Philadelphia", "Pomona", "Prospect", "Prospect Park", "Queensdale", "Quinnington", "Reitfontain", "Rhodesville", "Ridgeview", "Rolfe Valley", "Rugare", "Runiville", "Ryelands", "Seke", "Sentosa", "Shawasha Hills", "Sherwood Park", "Shortson", "Southerton", "St. Martins", "Strathaven", "Sugar Loaf Hill", "Sunningdale", "Sunridge", "Sunrise", "Sunway City", "Tafara", "The Grange", "Tynwald", "Umwinsidale", "Uplands", "Vainona", "Warren Park", "Waterfalls", "Westgate", "Westlea", "Westwood", "Willowvale", "Wilmington Park"];

export const getSuburb = (address) => {
  let addressParts = address.replace(/\n/g, ',').split(",");
  delete addressParts[0]
  addressParts = addressParts.filter(p => Boolean(p))

  let suburb = '';
  let suggestions = [];
  for(let i=0; i<addressParts.length; i++) {
    let part = addressParts[i];
    const partSuggestions = fuzzaldrin.filter(harareSuburbs, part);
    if (partSuggestions.length > 0) {
      suggestions = suggestions.concat(partSuggestions);
      suburb = partSuggestions[0];
    }
  }
  return suburb;
}




// WEBPACK FOOTER //
// ./src/helpers/index.js